'use strict';

exports.__esModule = true;
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2, _initialiseProps;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Element2 = require('./Element');

var _Element3 = _interopRequireDefault(_Element2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Integrate = (_temp2 = _class = function (_Element) {
  (0, _inherits3.default)(Integrate, _Element);

  function Integrate() {
    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Integrate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Element.call.apply(_Element, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  Integrate.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        name = _props.name,
        render = _props.render;

    var currentValue = this.getValue();
    var newProps = {
      name: name,
      value: currentValue,
      onChange: this.handleChange
    };

    if (typeof render === 'function') {
      return render(newProps);
    } else if (typeof children === 'function') {
      return children(newProps);
    }

    throw new Error('You need to set property render or children as function');
  };

  return Integrate;
}(_Element3.default), _class.propTypes = (0, _extends3.default)({}, _Element3.default.propTypes, {
  render: _propTypes2.default.func
}), _class.defaultProps = {
  render: undefined
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function () {
    _this2.setValue.apply(_this2, arguments);
  };
}, _temp2);
exports.default = Integrate;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Integrate.js
 ** module id = 1276
 ** module chunks = 0
 **/